module.exports = __webpack_public_path__ + "static/WEB0-aef821edcea50a428d7ecdc8ea5a94d9.png";